import { gql } from '@apollo/client';

export const LOGIN_MUTATION = gql`
  mutation login($email: String!, $password: String!) {
    createToken(email: $email, password: $password, context: "ALUNO") {
      token
    }
  }
`;
